import FinalBox from '../lib/FinalBox.class.js';

document.addEventListener('demodal', (e) => {
	FinalBox.getEffectiveInstance().close();
});


